import React from "react";
import { Box, IconButton, Tooltip } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import EditIcon from "@mui/icons-material/Edit";
import ChangeCircleIcon from "@mui/icons-material/ChangeCircle";
import LocationOffIcon from "@mui/icons-material/LocationOff";
import DeleteIcon from "@mui/icons-material/Delete";
import dayjs from "dayjs";

const InvoiceTemplateTable = React.memo(
  ({
    rows,
    loading,
    totalRowCount,
    paginationModel,
    onPaginationModelChange,
    // Các hàm xử lý hành động (Giữ nguyên logic của bạn)
    handleEdit,
    handleUnActiveTemplate,
    handleOpenConfirmDeleteModal,
  }) => {
    // Bê nguyên mảng columns từ file cũ sang đây
    const columns = [
      {
        field: "ItLocation",
        headerName: "Địa điểm/Máy tính tiền",
        headerAlign: "center",
        width: 373,
      },
      {
        field: "ItInvoiceTypeName",
        headerName: "Loại hóa đơn",
        headerAlign: "center",
        width: 400,
      },
      {
        field: "ItSign",
        headerName: "Ký hiệu hóa đơn",
        headerAlign: "center",
        align: "center",
        width: 125,
      },
      {
        field: "ItCQTFull",
        headerName: "Mã CQT sẽ cấp",
        headerAlign: "center",
        width: 200,
      },
      {
        field: "ItToken",
        headerName: "Token kết nối",
        headerAlign: "center",
        width: 300,
      },
      {
        field: "ItCreateDate",
        headerName: "Ngày tạo",
        headerAlign: "center",
        width: 120,
        align: "center",
        valueFormatter: (params) =>
          params ? dayjs(params).format("DD/MM/YYYY") : "",
      },
      {
        field: "ItCreateName",
        headerName: "Người tạo",
        headerAlign: "center",
        width: 150,
      },
      {
        field: "ItIsActive",
        headerName: "Hoạt động",
        headerAlign: "center",
        type: "boolean",
        width: 90,
      },
      {
        field: "actions",
        headerName: "Chức năng",
        headerAlign: "center",
        type: "actions",
        width: 120,
        renderCell: (params) => (
          <Box>
            {params.row.ItIsActive && (
              <>
                <Tooltip title="Sửa ký hiệu" arrow>
                  <IconButton
                    color="primary"
                    size="small"
                    onClick={() => handleEdit(params.row.ItId, false)}
                  >
                    <EditIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Thay thế ký hiệu" arrow>
                  <IconButton
                    color="primary"
                    size="small"
                    onClick={() => handleEdit(params.row.ItId, true)}
                  >
                    <ChangeCircleIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Ngưng hoạt động" arrow>
                  <IconButton
                    color="error"
                    size="small"
                    onClick={() => handleUnActiveTemplate(params.row.ItId)}
                  >
                    <LocationOffIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              </>
            )}
            <Tooltip title="Xóa ký hiệu" arrow>
              <IconButton
                color="error"
                size="small"
                onClick={() => handleOpenConfirmDeleteModal(params.row.ItId)}
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Box>
        ),
      },
    ];

    return (
      <Box sx={{ flexGrow: 1, width: "100%" }}>
        <DataGrid
          rows={rows}
          columns={columns}
          paginationMode="server"
          rowCount={totalRowCount}
          paginationModel={paginationModel}
          onPaginationModelChange={onPaginationModelChange}
          pageSizeOptions={[5, 10, 20, 50]}
          disableRowSelectionOnClick
          showCellVerticalBorder
          showColumnVerticalBorder
          loading={loading}
          getRowId={(row) => row.ItId}
          slots={{
            noRowsOverlay: () => (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100%",
                }}
              >
                Không có ký hiệu nào được tìm thấy.
              </Box>
            ),
          }}
          getRowClassName={(params) =>
            params.row.ItIsActive === false ? "row-unactive" : "row-default"
          }
          sx={{
            ".row-unactive": { color: "#ff1f1fff" },
          }}
        />
      </Box>
    );
  },
);

export default InvoiceTemplateTable;
